import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum CourseFields {
    CUSTOM_ID = 'customId',

    SUBJECT = 'subject',
    TEACHER = 'teacher',
    OWNING_TEACHER = 'owningTeacher',
    STUDENT_ITEMS = 'studentItems',
    ROOM = 'room',
    INSTITUTION = 'institution',

    DAY_OF_WEEK = 'dayOfWeek',
    START_DATE = 'startDate',
    END_DATE = 'endDate',
    TIME_RANGE = 'timeRange',
    IS_ALL_DAY = 'isAllDay',
    WEEK_INTERVAL = 'weekInterval',

    INDIVIDUAL_HOLIDAYS_APPLY = 'individualHolidaysApply',
    SCHOOL_HOLIDAYS_APPLY = 'schoolHolidaysApply',
    PUBLIC_HOLIDAYS_APPLY = 'publicHolidaysApply',

    COURSE_STATE = 'courseState',
    IS_OPEN_FOR_REGISTRATION = 'isOpenForRegistration',

    IS_UNPROFITABLE = 'isUnprofitable',
    PROFIT_REPORT = 'profitReport',

    STATE_HOLIDAYS_APPLY = 'stateHolidaysApply',
    COUNTRY_HOLIDAYS_APPLY = 'countryHolidaysApply',

    PREDECESSOR = 'predecessor',
    SUCCESSOR = 'successor',

    SUBSTITUTION_INQUIRY = 'substitutionInquiry',

    MAKEUP = 'makeup',

    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace CourseFields {
    type Data = {
        text: string;
        readOnly?: true;
    }

    export const Record: Record<CourseFields, Data> = {
        [CourseFields.CUSTOM_ID]: {
            text: 'Kursnummer',
            readOnly: true,
        },
        [CourseFields.SUBJECT]: {
            text: 'Fach',
        },
        [CourseFields.TEACHER]: {
            text: 'Lehrkraft',
        },
        [CourseFields.OWNING_TEACHER]: {
            text: 'Reguläre Lehrkraft',
        },
        [CourseFields.STUDENT_ITEMS]: {
            text: 'Schüler',
        },
        [CourseFields.ROOM]: {
            text: 'Raum',
        },
        [CourseFields.INSTITUTION]: {
            text: 'Standort',
        },
        [CourseFields.DAY_OF_WEEK]: {
            text: 'Wochentag',
        },
        [CourseFields.START_DATE]: {
            text: 'Startdatum des Kursplans',
        },
        [CourseFields.END_DATE]: {
            text: 'Enddatum des Kursplans',
        },
        [CourseFields.TIME_RANGE]: {
            text: 'Zeitraum',
        },
        [CourseFields.IS_ALL_DAY]: {
            text: 'Ganztägig',
        },
        [CourseFields.WEEK_INTERVAL]: {
            text: 'Wochenintervall',
        },
        [CourseFields.INDIVIDUAL_HOLIDAYS_APPLY]: {
            text: 'Gültigkeit von Standortferien',
        },
        [CourseFields.SCHOOL_HOLIDAYS_APPLY]: {
            text: 'Gültigkeit von Schulferien',
        },
        [CourseFields.PUBLIC_HOLIDAYS_APPLY]: {
            text: 'Gültigkeit von Feiertagen',
        },
        [CourseFields.COURSE_STATE]: {
            text: 'Kursstatus',
        },
        [CourseFields.IS_OPEN_FOR_REGISTRATION]: {
            text: 'Offen für Anmeldungen',
        },
        [CourseFields.IS_UNPROFITABLE]: {
            text: 'Rentabilitätsstatus',
            readOnly: true,
        },
        [CourseFields.PROFIT_REPORT]: {
            text: 'Rentabilitätsbericht',
            readOnly: true,
        },
        [CourseFields.STATE_HOLIDAYS_APPLY]: {
            text: 'Gültigkeit von Ferien und Feiertagen des Bundeslandes',
        },
        [CourseFields.COUNTRY_HOLIDAYS_APPLY]: {
            text: 'Gültigkeit von landesweiten Ferien und Feiertagen',
        },
        [CourseFields.PREDECESSOR]: {
            text: 'Vorgänger',
            readOnly: true,
        },
        [CourseFields.SUCCESSOR]: {
            text: 'Nachfolger',
            readOnly: true,
        },
        [CourseFields.SUBSTITUTION_INQUIRY]: {
            text: 'Vertretungsanfrage',
            readOnly: true,
        },
        [CourseFields.MAKEUP]: {
            text: 'Nachholtermin (Bezug zur ausgefallenen Stunde)',
            readOnly: true,
        },
        [CourseFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readOnly: true,
        },
        [CourseFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
            readOnly: true,
        },
    }

    export const Items = mapRecordToItems(Record);
}

